(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["resin-furnish-world"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    const page = document.querySelector('.rsrooms-enhanced');
    if (!page || page.dataset.enhancedReady) return;
    page.dataset.enhancedReady = 'true';
    const nav = page.querySelector('.rsrooms-nav');
    const toggles = [...nav.querySelectorAll('.rsrooms-menu-toggle')];
    let active = null;
    const close = (restoreFocus = false) => {
      if (!active) return;
      const trigger = active;
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      active = null;
      if (restoreFocus) trigger.focus();
    };
    toggles.forEach(trigger => trigger.addEventListener('click', () => {
      const wasOpen = active === trigger;
      close();
      if (wasOpen) return;
      active = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = false;
    }));
    nav.addEventListener('click', event => {
      if (event.target.closest('[data-room-close]')) close(true);
      else if (event.target.closest('a')) close();
    });
    nav.addEventListener('keydown', event => {
      if (event.key === 'Escape' && active) { event.preventDefault(); close(true); }
      else if (event.key === 'ArrowDown' && toggles.includes(event.target)) {
        event.preventDefault();
        if (active !== event.target) event.target.click();
        document.getElementById(event.target.getAttribute('aria-controls')).querySelector('a').focus();
      } else if (event.key === 'Tab' && !event.shiftKey && active === event.target) {
        event.preventDefault();
        document.getElementById(active.getAttribute('aria-controls')).querySelector('button').focus();
      }
    });
    document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) close(); });
    document.addEventListener('focusin', event => { if (!nav.contains(event.target)) close(); });
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 761px)');
    const scenes = [...page.querySelectorAll('.rsrooms-scene')];

    const positionArtfulPoints = () => {
      const phone = !desktop.matches;
      const zoom = 1;
      scenes.forEach(scene => {
        const media = scene.querySelector('.rsrooms-scene-media');
        const img = media.querySelector('img');
        const width = media.clientWidth, height = media.clientHeight;
        const iw = phone ? 1122 : 1672, ih = phone ? 1402 : 941;
        const fit = Math.max(width / iw, height / ih);
        scene.querySelectorAll('[data-artful-point]').forEach(dot => {
          const values = dot.dataset.artfulPoint.split(',').map(Number);
          const px = values[phone ? 2 : 0], py = values[phone ? 3 : 1];
          const x = 50 + (px - 50) * iw * fit * zoom / width;
          const y = 50 + (py - 50) * ih * fit * zoom / height;
          dot.style.left = x + '%'; dot.style.top = y + '%';
          dot.style.setProperty('--mx', x + '%'); dot.style.setProperty('--my', y + '%');
        });
      });
    };
    positionArtfulPoints();
    window.addEventListener('resize', positionArtfulPoints, {passive:true});
    const runway = page.querySelector('.rsrooms-runway');
    const stage = page.querySelector('.rsrooms-stage');
    const track = page.querySelector('.rsrooms-track');
    const controls = page.querySelector('.rsrooms-gallery-controls');
    const previous = controls.querySelector('[data-room-previous]');
    const next = controls.querySelector('[data-room-next]');
    const count = controls.querySelector('.rsrooms-gallery-count');
    let horizontal = false, step = 1, start = 0, panelWidth = 0, current = -1, scheduled = false;
    let wheelTotal = 0, wheelDirection = 0, wheelTime = -Infinity, wheelConsumed = false, lockedUntil = 0;
    const title = index => scenes[index].querySelector('h1,h2').textContent;
    const draw = () => {
      scheduled = false;
      if (!horizontal) return;
      const progress = Math.max(0, Math.min(scenes.length - 1, (scrollY - start) / step));
      const index = Math.round(progress);
      page.style.setProperty('--gallery-x', `${-index * panelWidth}px`);
      page.dataset.galleryIndex = index;
      if (current === index) return;
      current = index;
      scenes.forEach((scene, i) => { scene.inert = i !== index; });
      count.textContent = `${String(index + 1).padStart(2,'0')} / ${String(scenes.length).padStart(2,'0')}`;
      previous.disabled = index === 0;
      next.disabled = index === scenes.length - 1;
      previous.setAttribute('aria-label', title(Math.max(0,index - 1)));
      next.setAttribute('aria-label', title(Math.min(scenes.length - 1,index + 1)));
      scenes.slice(Math.max(0,index - 1),index + 3).forEach(scene => { scene.querySelector('img').loading = 'eager'; });
    };
    const requestDraw = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(draw); } };
    const measure = () => {
      horizontal = desktop.matches && !motion.matches && innerHeight > 480;
      page.classList.toggle('rsrooms-horizontal', horizontal);
      if (!horizontal) {
        scenes.forEach(scene => { scene.inert = false; });
        current = -1;
        positionArtfulPoints();
        return;
      }
      const top = nav.offsetHeight;
      const height = innerHeight - top;
      step = Math.max(360, height * .8);
      panelWidth = page.getBoundingClientRect().width;
      page.style.setProperty('--gallery-top', `${top}px`);
      page.style.setProperty('--gallery-height', `${height}px`);
      page.style.setProperty('--gallery-runway', `${height + step * (scenes.length - 1)}px`);
      start = runway.getBoundingClientRect().top + scrollY - top;
      positionArtfulPoints();
      draw();
    };
    const go = (index, focus = false) => {
      index = Math.max(0,Math.min(scenes.length - 1,index));
      if (!horizontal) return;
      window.scrollTo({top:start + index * step,behavior:'instant'});
      draw();
      if (focus) {
        const heading = scenes[index].querySelector('h1,h2');
        heading.tabIndex = -1;
        heading.focus({preventScroll:true});
      }
    };
    page.addEventListener('wheel', event => {
      if (!horizontal || event.ctrlKey || event.metaKey || event.defaultPrevented || nav.contains(event.target)) return;
      const end = start + step * (scenes.length - 1);
      if (scrollY < start - 2 || scrollY > end + 2) return;
      if (event.target.closest('input,textarea,select,[contenteditable="true"],[role="dialog"]')) return;
      const raw = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (!raw) return;
      const delta = raw * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1);
      const direction = Math.sign(delta);
      const now = performance.now();
      if (now - wheelTime > 180 || direction !== wheelDirection) {
        wheelTotal = 0;
        wheelConsumed = false;
      }
      wheelTime = now;
      wheelDirection = direction;
      if (now < lockedUntil || wheelConsumed) {
        event.preventDefault();
        return;
      }
      if ((current === 0 && direction < 0) || (current === scenes.length - 1 && direction > 0)) return;
      event.preventDefault();
      wheelTotal += Math.abs(delta);
      if (wheelTotal < 18) return;
      wheelConsumed = true;
      lockedUntil = now + 460;
      wheelTotal = 0;
      go(current + direction);
    }, {passive:false});
    page.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || !horizontal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      const index = scenes.findIndex(scene => '#' + scene.id === anchor.getAttribute('href'));
      if (index < 0) return;
      event.preventDefault();
      history.pushState(null,'',anchor.getAttribute('href'));
      go(index,true);
    });
    previous.addEventListener('click', () => go(current - 1));
    next.addEventListener('click', () => go(current + 1));
    const followHash = () => {
      const index = scenes.findIndex(scene => '#' + scene.id === location.hash);
      if (index >= 0 && horizontal) go(index);
    };
    const navSize = new ResizeObserver(() => {
      page.style.setProperty('--room-nav-height', `${nav.offsetHeight + 8}px`);
      measure();
    });
    navSize.observe(nav);
    window.addEventListener('scroll', requestDraw, {passive:true});
    window.addEventListener('resize', measure, {passive:true});
    window.addEventListener('hashchange', followHash);
    window.addEventListener('popstate', followHash);
    window.addEventListener('pageshow', () => { measure(); followHash(); });
    motion.addEventListener('change', measure);
    desktop.addEventListener('change', measure);
    measure();
    followHash();

    const placeReviews = () => {
      const footer = document.querySelector('footer.footer-group');
      const badge = document.querySelector('.jdgm-trust-badge-widget');
      const strip = badge && badge.closest('.shopify-section-group-footer-group');
      const copyright = footer && footer.querySelector('[id$="__footer-copyright"]');
      if (!footer || !strip || !copyright) return false;
      footer.classList.add('rsrooms-furnish-footer');
      strip.classList.add('rsrooms-reviews-strip');
      if (strip.nextElementSibling !== copyright) footer.insertBefore(strip, copyright);
      return true;
    };
    if (!placeReviews()) {
      const observer = new MutationObserver(() => { if (placeReviews()) observer.disconnect(); });
      observer.observe(document.body, {childList:true,subtree:true});
      setTimeout(() => observer.disconnect(), 20000);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resin-home-product-picks"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-product-orbit')) {
    customElements.define('rs-product-orbit', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected || this.controller) return;
        this.track = this.querySelector('.rs-orbit__track');
        this.cards = Array.from(this.track?.querySelectorAll('.resin-home-product-card') || []);
        if (this.cards.length < 2) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.current = 1;
        this.count = this.querySelector('.rs-orbit__count');
        this.status = this.querySelector('.rs-orbit__status');
        this.querySelector('.rs-orbit__controls').hidden = false;
        this.setAttribute('data-ready', '');
        this.querySelector('.rs-orbit__previous').addEventListener('click', () => this.move(-1), options);
        this.querySelector('.rs-orbit__next').addEventListener('click', () => this.move(1), options);
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const focusCard = this.cards.includes(document.activeElement);
          if (event.key === 'Home') this.select(0);
          else if (event.key === 'End') this.select(this.cards.length - 1);
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
          if (focusCard) this.cards[this.current].focus({ preventScroll: true });
        }, options);
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.pointer = { x: event.clientX, y: event.clientY, id: event.pointerId };
          this.suppressClick = false;
        }, options);
        this.track.addEventListener('pointerup', event => {
          if (!this.pointer || this.pointer.id !== event.pointerId) return;
          const dx = event.clientX - this.pointer.x;
          const dy = event.clientY - this.pointer.y;
          this.pointer = null;
          if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            this.suppressClick = true;
            this.move(dx < 0 ? 1 : -1);
          }
        }, options);
        this.track.addEventListener('pointercancel', () => { this.pointer = null; }, options);
        this.track.addEventListener('click', event => {
          const card = event.target.closest('.resin-home-product-card');
          if (!card) return;
          if (this.suppressClick) {
            event.preventDefault();
            this.suppressClick = false;
            return;
          }
          const index = this.cards.indexOf(card);
          if (index !== this.current && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
            event.preventDefault();
            this.select(index);
          }
        }, options);
        this.observer = new ResizeObserver(() => this.paint());
        this.observer.observe(this.track);
        this.cards.forEach(card => this.observer.observe(card));
        this.paint();
      }
      move(direction) { this.select((this.current + direction + this.cards.length) % this.cards.length); }
      select(index) {
        const focusCard = this.cards.includes(document.activeElement);
        this.current = index;
        this.paint();
        if (focusCard) this.cards[index].focus({ preventScroll: true });
        this.status.textContent = `${index + 1} / ${this.cards.length} — ${this.cards[index].querySelector('.resin-home-product-card__title')?.textContent.trim() || ''}`;
      }
      paint() {
        if (!this.cards || !this.isConnected) return;
        const radius = Math.min(this.track.clientWidth * .48, 530);
        this.cards.forEach((card, index) => {
          let offset = (index - this.current + this.cards.length) % this.cards.length;
          if (offset > this.cards.length / 2) offset -= this.cards.length;
          const distance = Math.abs(offset);
          const angle = offset * Math.PI / 4;
          card.style.setProperty('--orbit-x', `${Math.sin(angle) * radius}px`);
          card.style.setProperty('--orbit-z', `${(Math.cos(angle) - 1) * radius * 1.05}px`);
          card.style.setProperty('--orbit-angle', `${-offset * 19}deg`);
          card.style.setProperty('--orbit-scale', distance === 0 ? '1.06' : '1');
          card.style.setProperty('--orbit-order', String(10 - distance));
          card.style.setProperty('--orbit-opacity', distance <= 2 ? '1' : '0');
          card.style.setProperty('--orbit-visibility', distance <= 2 ? 'visible' : 'hidden');
          card.style.setProperty('--orbit-pointer', distance <= 1 ? 'auto' : 'none');
          card.toggleAttribute('data-current', distance === 0);
          card.tabIndex = distance === 0 ? 0 : -1;
          card.setAttribute('aria-hidden', distance === 0 ? 'false' : 'true');
        });
        this.count.textContent = `${String(this.current + 1).padStart(2, '0')} / ${String(this.cards.length).padStart(2, '0')}`;
        const height = Math.ceil(Math.max(...this.cards.map(card => card.offsetHeight)) * 1.06) + 48;
        this.track.style.setProperty('--orbit-height', `${height}px`);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resin-journal-article"]) return;
  try {
    
  document.querySelectorAll('[data-journal-article]').forEach((article) => {
    const content = article.querySelector('[data-journal-content]');
    const toc = article.querySelector('[data-journal-toc]');
    const list = article.querySelector('[data-journal-toc-list]');
    if (!content || !toc || !list) return;
    const headings = content.querySelectorAll('h2, h3');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `journal-section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });
    if (headings.length > 1) toc.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resin-journal"] && !Shopify.designMode) return;
  try {
    
function initRsJournalAds(scope) {
  if (!window.matchMedia('(min-width:991px)').matches) return;
  const boxes = scope.querySelectorAll('[data-rs-listing-ad]');
  if (!boxes.length) return;
  const aside = scope.querySelector('.rs-journal__aside');
  const feed = scope.querySelector('.rs-journal__feed-grid');
  const note = scope.querySelector('.rs-journal__aside-note');
  const alignRows = () => {
    if (!aside || !feed || !note || !window.matchMedia('(min-width:991px)').matches) return;
    const origin = aside.getBoundingClientRect().top;
    const minimum = note.getBoundingClientRect().bottom - origin + 48;
    const rows = [...feed.children].filter((card, index) => index % 2 === 0).map(card => card.getBoundingClientRect().top - origin);
    const first = rows.findIndex(top => top >= minimum);
    if (first < 0) { aside.classList.remove('rs-journal__aside--ad-rows'); return; }
    aside.classList.add('rs-journal__aside--ad-rows');
    boxes[0].style.setProperty('--rs-ad-row', `${rows[first]}px`);
    const second = rows[first] + boxes[0].getBoundingClientRect().height + 32;
    boxes[1].style.setProperty('--rs-ad-row', `${second}px`);
  };
  alignRows();
  if ('ResizeObserver' in window && feed && note) {
    let frame;
    const resize = new ResizeObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(alignRows);
    });
    resize.observe(feed);
    resize.observe(note);
    resize.observe(boxes[0]);
  }
  const requestAd = box => {
    if (box.dataset.requested || !window.matchMedia('(min-width:991px)').matches) return;
    const available = box.clientWidth - 2;
    if (available < 200) return;
    const width = available >= 300 ? 300 : available >= 250 ? 250 : 200;
    const unit = document.createElement('ins');
    unit.className = 'adsbygoogle';
    unit.style.width = `${width}px`;
    unit.style.height = '250px';
    unit.dataset.adClient = 'ca-pub-6589105932304751';
    unit.dataset.adSlot = '8250979662';
    box.dataset.requested = 'true';
    box.append(unit);
    if (!document.querySelector('script[src*="pagead/js/adsbygoogle.js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6589105932304751';
      document.head.append(script);
    }
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (error) {}
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          requestAd(entry.target);
          if (entry.target.dataset.requested) observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    boxes.forEach(box => observer.observe(box));
  } else {
    boxes.forEach(requestAd);
  }
}
initRsJournalAds(document);
document.addEventListener('shopify:section:load', event => initRsJournalAds(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resin-make-studio"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    const page = document.querySelector('.rs-make-v2');
    if (!page || page.dataset.makeReady) return;
    page.dataset.makeReady = 'true';
    const nav = page.querySelector('.rsm-nav');
    const toggles = [...nav.querySelectorAll('.rsm-menu-toggle')];
    const scenes = [...page.querySelectorAll('.rsm-scene')];
    const runway = page.querySelector('.rsm-runway');
    const controls = page.querySelector('.rsm-gallery-controls');
    const previous = controls.querySelector('[data-make-previous]');
    const next = controls.querySelector('[data-make-next]');
    const count = controls.querySelector('.rsm-gallery-count');
    const desktop = matchMedia('(min-width:761px)');
    const motion = matchMedia('(prefers-reduced-motion:reduce)');
    let activeMenu = null;
    const closeMenu = (focus = false) => {
      if (!activeMenu) return;
      const trigger = activeMenu;
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      activeMenu = null;
      if (focus) trigger.focus();
    };
    toggles.forEach(trigger => trigger.addEventListener('click', () => {
      const open = activeMenu === trigger;
      closeMenu();
      if (open) return;
      activeMenu = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = false;
    }));
    nav.addEventListener('click', event => {
      if (event.target.closest('[data-make-close]')) closeMenu(true);
      else if (event.target.closest('a')) closeMenu();
    });
    nav.addEventListener('keydown', event => { if (event.key === 'Escape' && activeMenu) { event.preventDefault(); closeMenu(true); } });
    document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) closeMenu(); });
    document.addEventListener('focusin', event => { if (!nav.contains(event.target)) closeMenu(); });
    let horizontal = false, step = 1, start = 0, width = 0, current = -1, scheduled = false;
    let wheelTotal = 0, wheelDirection = 0, wheelTime = -Infinity, wheelConsumed = false, lockedUntil = 0;
    const setActive = index => {
      page.querySelectorAll('.rsm-menu-item').forEach((item, i) => item.classList.toggle('is-active', i === index));
      count.textContent = `${String(index + 1).padStart(2,'0')} / ${String(scenes.length).padStart(2,'0')}`;
      previous.disabled = index === 0;
      next.disabled = index === scenes.length - 1;
      previous.setAttribute('aria-label', `Previous: ${scenes[Math.max(0,index - 1)].querySelector('h1,h2').textContent}`);
      next.setAttribute('aria-label', `Next: ${scenes[Math.min(scenes.length - 1,index + 1)].querySelector('h1,h2').textContent}`);
    };
    const draw = () => {
      scheduled = false;
      if (!horizontal) return;
      const index = Math.round(Math.max(0, Math.min(scenes.length - 1, (scrollY - start) / step)));
      page.style.setProperty('--make-x', `${-index * width}px`);
      if (current === index) return;
      current = index;
      scenes.forEach((scene, i) => { scene.inert = i !== index; });
      scenes.slice(Math.max(0,index - 1),index + 3).forEach(scene => { scene.querySelector('img').loading = 'eager'; });
      setActive(index);
    };
    const requestDraw = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(draw); } };
    const measure = () => {
      horizontal = desktop.matches && !motion.matches && innerHeight > 480;
      page.classList.toggle('rsm-horizontal', horizontal);
      const top = nav.offsetHeight;
      page.style.setProperty('--make-nav-height', `${top}px`);
      if (!horizontal) { scenes.forEach(scene => { scene.inert = false; }); current = -1; return; }
      const height = innerHeight - top;
      step = Math.max(360, height * .8);
      width = page.getBoundingClientRect().width;
      page.style.setProperty('--make-stage-height', `${height}px`);
      page.style.setProperty('--make-runway', `${height + step * (scenes.length - 1)}px`);
      start = runway.getBoundingClientRect().top + scrollY - top;
      draw();
    };
    const go = (index, focus = false) => {
      index = Math.max(0, Math.min(scenes.length - 1, index));
      if (!horizontal) { scenes[index].scrollIntoView({behavior:'smooth'}); return; }
      window.scrollTo({top:start + index * step,behavior:'instant'});
      draw();
      if (focus) { const heading = scenes[index].querySelector('h1,h2'); heading.tabIndex = -1; heading.focus({preventScroll:true}); }
    };
    page.addEventListener('wheel', event => {
      if (!horizontal || event.ctrlKey || event.metaKey || event.defaultPrevented || nav.contains(event.target)) return;
      if (scrollY < start - 2 || scrollY > start + step * (scenes.length - 1) + 2) return;
      if (event.target.closest('input,textarea,select,[contenteditable="true"],[role="dialog"]')) return;
      const raw = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (!raw) return;
      const delta = raw * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1);
      const direction = Math.sign(delta);
      const now = performance.now();
      if (now - wheelTime > 180 || direction !== wheelDirection) { wheelTotal = 0; wheelConsumed = false; }
      wheelTime = now; wheelDirection = direction;
      if (now < lockedUntil || wheelConsumed) { event.preventDefault(); return; }
      if ((current === 0 && direction < 0) || (current === scenes.length - 1 && direction > 0)) return;
      event.preventDefault();
      wheelTotal += Math.abs(delta);
      if (wheelTotal < 18) return;
      wheelConsumed = true; lockedUntil = now + 460; wheelTotal = 0;
      go(current + direction);
    }, {passive:false});
    page.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      const index = scenes.findIndex(scene => '#' + scene.id === anchor.getAttribute('href'));
      if (index < 0) return;
      event.preventDefault();
      history.pushState(null,'',anchor.getAttribute('href'));
      go(index,true);
    });
    previous.addEventListener('click', () => go(current - 1));
    next.addEventListener('click', () => go(current + 1));
    const followHash = () => { const index = scenes.findIndex(scene => '#' + scene.id === location.hash); if (index >= 0) go(index); };
    new ResizeObserver(measure).observe(nav);
    window.addEventListener('scroll', requestDraw, {passive:true});
    window.addEventListener('resize', measure, {passive:true});
    window.addEventListener('hashchange', followHash);
    window.addEventListener('popstate', followHash);
    window.addEventListener('pageshow', () => { measure(); followHash(); });
    desktop.addEventListener('change', measure);
    motion.addEventListener('change', measure);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { if (horizontal) return; entries.forEach(entry => { if (entry.isIntersecting) setActive(scenes.indexOf(entry.target)); }); }, {threshold:.55});
      scenes.forEach(scene => observer.observe(scene));
    }
    measure(); followHash();
    const placeReviews = () => {
      const footer = document.querySelector('footer.footer-group');
      const badge = document.querySelector('.jdgm-trust-badge-widget');
      const strip = badge && badge.closest('.shopify-section-group-footer-group');
      const copyright = footer && footer.querySelector('[id$="__footer-copyright"]');
      if (!footer || !strip || !copyright) return false;
      footer.classList.add('rs-make-footer');
      strip.classList.add('rsm-reviews-strip');
      if (strip.nextElementSibling !== copyright) footer.insertBefore(strip, copyright);
      return true;
    };
    if (!placeReviews()) {
      const observer = new MutationObserver(() => { if (placeReviews()) observer.disconnect(); });
      observer.observe(document.body, {childList:true,subtree:true});
      setTimeout(() => observer.disconnect(), 20000);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resin-shop-directory-v6"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rsshop-rail').forEach((rail) => {
    const track = rail.querySelector('.rsshop-rail__track');
    rail.querySelectorAll('.rsshop-rail__arrows button').forEach((button) => {
      button.addEventListener('click', () => {
        const first = track.querySelector('.rsshop-product');
        if (!first) return;
        const distance = first.getBoundingClientRect().width + 18;
        track.scrollBy({ left: (button.dataset.direction === 'next' ? 1 : -1) * distance, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-catalog-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.rs-editorial').forEach(section => {
  const rail = section.querySelector('.rs-editorial__rail');
  if (rail.dataset.ready || !rail.children.length) return;
  rail.dataset.ready = 'true';
  const originals = [...rail.children];
  const count = originals.length;
  for (const side of ['before', 'after']) {
    const fragment = document.createDocumentFragment();
    originals.forEach(slide => {
      const copy = slide.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.querySelectorAll('a,button').forEach(el => el.setAttribute('tabindex','-1'));
      fragment.append(copy);
    });
    if (side === 'before') rail.prepend(fragment); else rail.append(fragment);
  }
  const slides = [...rail.children];
  const position = i => slides[i].offsetLeft - slides[0].offsetLeft;
  let timer;
  const nearest = () => slides.reduce((best,slide,i) => Math.abs(position(i)-rail.scrollLeft)<Math.abs(position(best)-rail.scrollLeft)?i:best,0);
  const settle = () => {
    const i=nearest();
    if(i<count) rail.scrollTo({left:position(i+count),behavior:'instant'});
    else if(i>=count*2) rail.scrollTo({left:position(i-count),behavior:'instant'});
    section.querySelector('.rs-editorial__counter').textContent=`${i%count+1} / ${count}`;
  };
  const move = direction => rail.scrollTo({left:position(Math.max(0,Math.min(slides.length-1,nearest()+direction))),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  rail.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(settle,180);},{passive:true});
  rail.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
  section.querySelectorAll('[data-rs-slide]').forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.rsSlide))));
  requestAnimationFrame(()=>rail.scrollTo({left:position(count),behavior:'instant'}));
  new ResizeObserver(()=>rail.scrollTo({left:position(count+nearest()%count),behavior:'instant'})).observe(rail);
  const dialog=section.querySelector('dialog');
  const thumbs=[...dialog.querySelectorAll('[data-full-src]')];
  let modalIndex=0;
  const showImage=i=>{
    modalIndex=(i+thumbs.length)%thumbs.length;
    const thumb=thumbs[modalIndex];
    const img=dialog.querySelector('.rs-gallery-dialog__image');
    img.src=thumb.dataset.fullSrc;
    img.alt=thumb.querySelector('img').alt;
    thumbs.forEach((t,n)=>t.setAttribute('aria-pressed',String(n===modalIndex)));
  };
  section.querySelectorAll('[data-gallery-open]').forEach(button=>button.addEventListener('click',event=>{
    event.preventDefault();
    event.stopPropagation();
    const slide=button.closest('.rs-editorial__slide');
    showImage(slide?slides.indexOf(slide)%count:nearest()%count);
    dialog.showModal();
  }));
  dialog.querySelector('.rs-gallery-dialog__close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>event.stopPropagation());
  thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>showImage(i)));
  dialog.querySelectorAll('[data-modal-step]').forEach(button=>button.addEventListener('click',()=>showImage(modalIndex+Number(button.dataset.modalStep))));
  dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();showImage(modalIndex+(event.key==='ArrowRight'?1:-1));}});
  let paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
  let visible=true;
  const pause=section.querySelector('[data-rs-pause]');
  const syncPause=()=>{pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);};
  syncPause();
  pause.addEventListener('click',()=>{paused=!paused;syncPause();});
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;}).observe(rail);
  const autoplay=setInterval(()=>{
    if(!section.isConnected){clearInterval(autoplay);return;}
    if(count>1&&!paused&&visible&&!document.hidden&&!dialog.open&&!section.contains(document.activeElement))move(1);
  },3000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-creator-partners"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-rscp-step]');
    if (!button) return;
    const section = button.closest('.rscp');
    const rail = section && section.querySelector('.rscp__rail');
    const card = rail && rail.querySelector('.rscp__card');
    if (!rail || !card) return;
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    const direction = button.dataset.rscpStep === 'next' ? 1 : -1;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rail.scrollBy({left: direction * (card.getBoundingClientRect().width + gap) * 2, behavior: reduceMotion ? 'auto' : 'smooth'});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-cristel-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  function chatControl(root) {
    if (!root) return null;
    const button = root.querySelector('button[part~="activator"]');
    if (button) return button;
    for (const element of root.querySelectorAll('*')) {
      if (element.shadowRoot) {
        const found = chatControl(element.shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-rs-brand-chat]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const started = Date.now();
    const open = () => {
      const launcher = chatControl(document.querySelector('shopify-chat')?.shadowRoot);
      if (launcher) {
        if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
      } else if (Date.now() - started < 4000) {
        window.setTimeout(open, 200);
      } else {
        window.location.assign(link.href);
      }
    };
    open();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-curated-art"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-art-gallery')) customElements.define('rs-art-gallery', class extends HTMLElement {
    connectedCallback() { requestAnimationFrame(() => this.initialize()); }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.cards = [...this.querySelectorAll('.rs-art-gallery__piece')];
      if (!this.cards.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.current = 0;
      this.stage = this.querySelector('.rs-art-gallery__stage');
      this.dialog = this.querySelector('dialog');
      this.setAttribute('data-ready','');
      this.querySelector('.rs-art-gallery__controls').hidden = false;
      this.querySelector('[data-art-previous]').addEventListener('click',() => this.select(this.current-1),options);
      this.querySelector('[data-art-next]').addEventListener('click',() => this.select(this.current+1),options);
      this.querySelector('[data-art-expand]').addEventListener('click',() => {
        const card = this.cards[this.current];
        const image = card.querySelector('img');
        const full = this.dialog.querySelector('img');
        full.src = image.dataset.fullSrc || image.currentSrc || image.src;
        full.alt = image.alt;
        this.dialog.querySelector('p').textContent = card.querySelector('.rs-art-gallery__title').textContent;
        this.dialog.querySelector('a').href = card.href;
        this.dialog.showModal();
      },options);
      this.querySelector('[data-art-close]').addEventListener('click',() => this.dialog.close(),options);
      this.dialog.addEventListener('close',() => this.querySelector('[data-art-expand]').focus({preventScroll:true}),options);
      this.addEventListener('keydown',event => {
        if (this.dialog.open || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.cards.length-1);
        else this.select(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      },options);
      this.stage.addEventListener('dragstart',event => event.preventDefault(),options);
      this.stage.addEventListener('pointerdown',event => {
        if (event.isPrimary && event.button === 0) { this.pointer={x:event.clientX,y:event.clientY,id:event.pointerId}; this.suppressClick=false; }
      },options);
      this.stage.addEventListener('pointercancel',() => {this.pointer=null;},options);
      this.stage.addEventListener('pointerup',event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const dx=event.clientX-this.pointer.x,dy=event.clientY-this.pointer.y;
        this.pointer=null;
        if (Math.abs(dx)>35 && Math.abs(dx)>Math.abs(dy)*1.3) {this.suppressClick=true;this.select(this.current+(dx<0?1:-1));}
      },options);
      this.stage.addEventListener('click',event => {
        const card=event.target.closest('.rs-art-gallery__piece');
        if (!card) return;
        if(this.suppressClick) {event.preventDefault();this.suppressClick=false;return;}
        const index=this.cards.indexOf(card);
        if(index!==this.current && !event.ctrlKey && !event.metaKey && !event.shiftKey) {event.preventDefault();this.select(index);}
      },options);
      this.observer=new ResizeObserver(()=>this.paint());
      this.observer.observe(this.stage);
      this.paint();
    }
    select(index) {
      const focusCard=this.cards.includes(document.activeElement);
      this.current=(index+this.cards.length)%this.cards.length;
      this.paint();
      if(focusCard)this.cards[this.current].focus({preventScroll:true});
      this.querySelector('.rs-art-gallery__status').textContent=`${this.current+1} / ${this.cards.length} — ${this.cards[this.current].querySelector('.rs-art-gallery__title').textContent.trim()}`;
    }
    paint() {
      const radius=this.stage.clientWidth*.56;
      this.cards.forEach((card,index)=>{
        let offset=(index-this.current+this.cards.length)%this.cards.length;
        if(offset>this.cards.length/2)offset-=this.cards.length;
        const distance=Math.abs(offset),angle=offset*Math.PI/4;
        card.style.setProperty('--art-x',`${Math.sin(angle)*radius}px`);
        card.style.setProperty('--art-z',`${(Math.cos(angle)-1)*radius*1.2}px`);
        card.style.setProperty('--art-angle',`${-offset*17}deg`);
        card.style.setProperty('--art-scale',distance===0?'1':'0.9');
        card.style.setProperty('--art-order',String(10-distance));
        card.style.setProperty('--art-opacity',distance<=1?'1':'0');
        card.style.setProperty('--art-visibility',distance<=1?'visible':'hidden');
        card.style.setProperty('--art-pointer',distance<=1?'auto':'none');
        card.toggleAttribute('data-current',distance===0);
        card.tabIndex=distance===0?0:-1;
        card.setAttribute('aria-hidden',String(distance!==0));
      });
      this.querySelector('.rs-art-gallery__count').textContent=`${String(this.current+1).padStart(2,'0')} / ${String(this.cards.length).padStart(2,'0')}`;
    }
    disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();this.controller=null;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-furnish-preview"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    const page = document.querySelector('.rsrooms-enhanced');
    if (!page || page.dataset.enhancedReady) return;
    page.dataset.enhancedReady = 'true';
    const nav = page.querySelector('.rsrooms-nav');
    const toggles = [...nav.querySelectorAll('.rsrooms-menu-toggle')];
    let active = null;
    const close = (restoreFocus = false) => {
      if (!active) return;
      const trigger = active;
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      active = null;
      if (restoreFocus) trigger.focus();
    };
    toggles.forEach(trigger => trigger.addEventListener('click', () => {
      const wasOpen = active === trigger;
      close();
      if (wasOpen) return;
      active = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = false;
    }));
    nav.addEventListener('click', event => {
      if (event.target.closest('[data-room-close]')) close(true);
      else if (event.target.closest('a')) close();
    });
    nav.addEventListener('keydown', event => {
      if (event.key === 'Escape' && active) { event.preventDefault(); close(true); }
      else if (event.key === 'ArrowDown' && toggles.includes(event.target)) {
        event.preventDefault();
        if (active !== event.target) event.target.click();
        document.getElementById(event.target.getAttribute('aria-controls')).querySelector('a').focus();
      } else if (event.key === 'Tab' && !event.shiftKey && active === event.target) {
        event.preventDefault();
        document.getElementById(active.getAttribute('aria-controls')).querySelector('button').focus();
      }
    });
    document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) close(); });
    document.addEventListener('focusin', event => { if (!nav.contains(event.target)) close(); });
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 761px)');
    const scenes = [...page.querySelectorAll('.rsrooms-scene')];

    const positionArtfulPoints = () => {
      const phone = !desktop.matches;
      const zoom = 1;
      scenes.forEach(scene => {
        const media = scene.querySelector('.rsrooms-scene-media');
        const img = media.querySelector('img');
        const width = media.clientWidth, height = media.clientHeight;
        const iw = phone ? 1122 : 1672, ih = phone ? 1402 : 941;
        const fit = Math.max(width / iw, height / ih);
        scene.querySelectorAll('[data-artful-point]').forEach(dot => {
          const values = dot.dataset.artfulPoint.split(',').map(Number);
          const px = values[phone ? 2 : 0], py = values[phone ? 3 : 1];
          const x = 50 + (px - 50) * iw * fit * zoom / width;
          const y = 50 + (py - 50) * ih * fit * zoom / height;
          dot.style.left = x + '%'; dot.style.top = y + '%';
          dot.style.setProperty('--mx', x + '%'); dot.style.setProperty('--my', y + '%');
        });
      });
    };
    positionArtfulPoints();
    window.addEventListener('resize', positionArtfulPoints, {passive:true});
    const runway = page.querySelector('.rsrooms-runway');
    const stage = page.querySelector('.rsrooms-stage');
    const track = page.querySelector('.rsrooms-track');
    const controls = page.querySelector('.rsrooms-gallery-controls');
    const previous = controls.querySelector('[data-room-previous]');
    const next = controls.querySelector('[data-room-next]');
    const count = controls.querySelector('.rsrooms-gallery-count');
    let horizontal = false, step = 1, start = 0, panelWidth = 0, current = -1, scheduled = false;
    const title = index => scenes[index].querySelector('h1,h2').textContent;
    const draw = () => {
      scheduled = false;
      if (!horizontal) return;
      const progress = Math.max(0, Math.min(scenes.length - 1, (scrollY - start) / step));
      page.style.setProperty('--gallery-x', `${-progress * panelWidth}px`);
      const index = Math.round(progress);
      page.dataset.galleryIndex = index;
      if (current === index) return;
      current = index;
      scenes.forEach((scene, i) => { scene.inert = i !== index; });
      count.textContent = `${String(index + 1).padStart(2,'0')} / ${String(scenes.length).padStart(2,'0')}`;
      previous.disabled = index === 0;
      next.disabled = index === scenes.length - 1;
      previous.setAttribute('aria-label', title(Math.max(0,index - 1)));
      next.setAttribute('aria-label', title(Math.min(scenes.length - 1,index + 1)));
      scenes.slice(Math.max(0,index - 1),index + 3).forEach(scene => { scene.querySelector('img').loading = 'eager'; });
    };
    const requestDraw = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(draw); } };
    const measure = () => {
      horizontal = desktop.matches && !motion.matches && innerHeight > 480;
      page.classList.toggle('rsrooms-horizontal', horizontal);
      if (!horizontal) {
        scenes.forEach(scene => { scene.inert = false; });
        current = -1;
        positionArtfulPoints();
        return;
      }
      const top = nav.offsetHeight;
      const height = innerHeight - top;
      step = Math.max(360, height * .8);
      panelWidth = page.getBoundingClientRect().width;
      page.style.setProperty('--gallery-top', `${top}px`);
      page.style.setProperty('--gallery-height', `${height}px`);
      page.style.setProperty('--gallery-runway', `${height + step * (scenes.length - 1)}px`);
      start = runway.getBoundingClientRect().top + scrollY - top;
      positionArtfulPoints();
      draw();
    };
    const go = (index, focus = false) => {
      index = Math.max(0,Math.min(scenes.length - 1,index));
      if (!horizontal) return;
      window.scrollTo({top:start + index * step,behavior:'instant'});
      draw();
      if (focus) {
        const heading = scenes[index].querySelector('h1,h2');
        heading.tabIndex = -1;
        heading.focus({preventScroll:true});
      }
    };
    page.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || !horizontal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      const index = scenes.findIndex(scene => '#' + scene.id === anchor.getAttribute('href'));
      if (index < 0) return;
      event.preventDefault();
      history.pushState(null,'',anchor.getAttribute('href'));
      go(index,true);
    });
    previous.addEventListener('click', () => go(current - 1));
    next.addEventListener('click', () => go(current + 1));
    const followHash = () => {
      const index = scenes.findIndex(scene => '#' + scene.id === location.hash);
      if (index >= 0 && horizontal) go(index);
    };
    const navSize = new ResizeObserver(() => {
      page.style.setProperty('--room-nav-height', `${nav.offsetHeight + 8}px`);
      measure();
    });
    navSize.observe(nav);
    window.addEventListener('scroll', requestDraw, {passive:true});
    window.addEventListener('resize', measure, {passive:true});
    window.addEventListener('hashchange', followHash);
    window.addEventListener('popstate', followHash);
    window.addEventListener('pageshow', () => { measure(); followHash(); });
    motion.addEventListener('change', measure);
    desktop.addEventListener('change', measure);
    measure();
    followHash();

    const placeReviews = () => {
      const footer = document.querySelector('footer.footer-group');
      const badge = document.querySelector('.jdgm-trust-badge-widget');
      const strip = badge && badge.closest('.shopify-section-group-footer-group');
      const copyright = footer && footer.querySelector('[id$="__footer-copyright"]');
      if (!footer || !strip || !copyright) return false;
      footer.classList.add('rsrooms-furnish-footer');
      strip.classList.add('rsrooms-reviews-strip');
      if (strip.nextElementSibling !== copyright) footer.insertBefore(strip, copyright);
      return true;
    };
    if (!placeReviews()) {
      const observer = new MutationObserver(() => { if (placeReviews()) observer.disconnect(); });
      observer.observe(document.body, {childList:true,subtree:true});
      setTimeout(() => observer.disconnect(), 20000);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-make-refresh-preview"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    const page = document.querySelector('.rs-make-v2');
    if (!page || page.dataset.makeReady) return;
    page.dataset.makeReady = 'true';
    const nav = page.querySelector('.rsm-nav');
    const toggles = [...nav.querySelectorAll('.rsm-menu-toggle')];
    const scenes = [...page.querySelectorAll('.rsm-scene')];
    const runway = page.querySelector('.rsm-runway');
    const controls = page.querySelector('.rsm-gallery-controls');
    const previous = controls.querySelector('[data-make-previous]');
    const next = controls.querySelector('[data-make-next]');
    const count = controls.querySelector('.rsm-gallery-count');
    const desktop = matchMedia('(min-width:761px)');
    const motion = matchMedia('(prefers-reduced-motion:reduce)');
    let activeMenu = null;
    const closeMenu = (focus = false) => {
      if (!activeMenu) return;
      const trigger = activeMenu;
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      activeMenu = null;
      if (focus) trigger.focus();
    };
    toggles.forEach(trigger => trigger.addEventListener('click', () => {
      const open = activeMenu === trigger;
      closeMenu();
      if (open) return;
      activeMenu = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = false;
    }));
    nav.addEventListener('click', event => {
      if (event.target.closest('[data-make-close]')) closeMenu(true);
      else if (event.target.closest('a')) closeMenu();
    });
    nav.addEventListener('keydown', event => { if (event.key === 'Escape' && activeMenu) { event.preventDefault(); closeMenu(true); } });
    document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) closeMenu(); });
    document.addEventListener('focusin', event => { if (!nav.contains(event.target)) closeMenu(); });
    let horizontal = false, step = 1, start = 0, width = 0, current = -1, scheduled = false;
    let wheelTotal = 0, wheelDirection = 0, wheelTime = -Infinity, wheelConsumed = false, lockedUntil = 0;
    const setActive = index => {
      page.querySelectorAll('.rsm-menu-item').forEach((item, i) => item.classList.toggle('is-active', i === index));
      count.textContent = `${String(index + 1).padStart(2,'0')} / ${String(scenes.length).padStart(2,'0')}`;
      previous.disabled = index === 0;
      next.disabled = index === scenes.length - 1;
      previous.setAttribute('aria-label', `Previous: ${scenes[Math.max(0,index - 1)].querySelector('h1,h2').textContent}`);
      next.setAttribute('aria-label', `Next: ${scenes[Math.min(scenes.length - 1,index + 1)].querySelector('h1,h2').textContent}`);
    };
    const draw = () => {
      scheduled = false;
      if (!horizontal) return;
      const index = Math.round(Math.max(0, Math.min(scenes.length - 1, (scrollY - start) / step)));
      page.style.setProperty('--make-x', `${-index * width}px`);
      if (current === index) return;
      current = index;
      scenes.forEach((scene, i) => { scene.inert = i !== index; });
      scenes.slice(Math.max(0,index - 1),index + 3).forEach(scene => { scene.querySelector('img').loading = 'eager'; });
      setActive(index);
    };
    const requestDraw = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(draw); } };
    const measure = () => {
      horizontal = desktop.matches && !motion.matches && innerHeight > 480;
      page.classList.toggle('rsm-horizontal', horizontal);
      const top = nav.offsetHeight;
      page.style.setProperty('--make-nav-height', `${top}px`);
      if (!horizontal) { scenes.forEach(scene => { scene.inert = false; }); current = -1; return; }
      const height = innerHeight - top;
      step = Math.max(360, height * .8);
      width = page.getBoundingClientRect().width;
      page.style.setProperty('--make-stage-height', `${height}px`);
      page.style.setProperty('--make-runway', `${height + step * (scenes.length - 1)}px`);
      start = runway.getBoundingClientRect().top + scrollY - top;
      draw();
    };
    const go = (index, focus = false) => {
      index = Math.max(0, Math.min(scenes.length - 1, index));
      if (!horizontal) { scenes[index].scrollIntoView({behavior:'smooth'}); return; }
      window.scrollTo({top:start + index * step,behavior:'instant'});
      draw();
      if (focus) { const heading = scenes[index].querySelector('h1,h2'); heading.tabIndex = -1; heading.focus({preventScroll:true}); }
    };
    page.addEventListener('wheel', event => {
      if (!horizontal || event.ctrlKey || event.metaKey || event.defaultPrevented || nav.contains(event.target)) return;
      if (scrollY < start - 2 || scrollY > start + step * (scenes.length - 1) + 2) return;
      if (event.target.closest('input,textarea,select,[contenteditable="true"],[role="dialog"]')) return;
      const raw = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (!raw) return;
      const delta = raw * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1);
      const direction = Math.sign(delta);
      const now = performance.now();
      if (now - wheelTime > 180 || direction !== wheelDirection) { wheelTotal = 0; wheelConsumed = false; }
      wheelTime = now; wheelDirection = direction;
      if (now < lockedUntil || wheelConsumed) { event.preventDefault(); return; }
      if ((current === 0 && direction < 0) || (current === scenes.length - 1 && direction > 0)) return;
      event.preventDefault();
      wheelTotal += Math.abs(delta);
      if (wheelTotal < 18) return;
      wheelConsumed = true; lockedUntil = now + 460; wheelTotal = 0;
      go(current + direction);
    }, {passive:false});
    page.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      const index = scenes.findIndex(scene => '#' + scene.id === anchor.getAttribute('href'));
      if (index < 0) return;
      event.preventDefault();
      history.pushState(null,'',anchor.getAttribute('href'));
      go(index,true);
    });
    previous.addEventListener('click', () => go(current - 1));
    next.addEventListener('click', () => go(current + 1));
    const followHash = () => { const index = scenes.findIndex(scene => '#' + scene.id === location.hash); if (index >= 0) go(index); };
    new ResizeObserver(measure).observe(nav);
    window.addEventListener('scroll', requestDraw, {passive:true});
    window.addEventListener('resize', measure, {passive:true});
    window.addEventListener('hashchange', followHash);
    window.addEventListener('popstate', followHash);
    window.addEventListener('pageshow', () => { measure(); followHash(); });
    desktop.addEventListener('change', measure);
    motion.addEventListener('change', measure);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { if (horizontal) return; entries.forEach(entry => { if (entry.isIntersecting) setActive(scenes.indexOf(entry.target)); }); }, {threshold:.55});
      scenes.forEach(scene => observer.observe(scene));
    }
    measure(); followHash();
    const placeReviews = () => {
      const footer = document.querySelector('footer.footer-group');
      const badge = document.querySelector('.jdgm-trust-badge-widget');
      const strip = badge && badge.closest('.shopify-section-group-footer-group');
      const copyright = footer && footer.querySelector('[id$="__footer-copyright"]');
      if (!footer || !strip || !copyright) return false;
      footer.classList.add('rs-make-footer');
      strip.classList.add('rsm-reviews-strip');
      if (strip.nextElementSibling !== copyright) footer.insertBefore(strip, copyright);
      return true;
    };
    if (!placeReviews()) {
      const observer = new MutationObserver(() => { if (placeReviews()) observer.disconnect(); });
      observer.observe(document.body, {childList:true,subtree:true});
      setTimeout(() => observer.disconnect(), 20000);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-maker-collection-index"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rs-maker-index').forEach(function (root) {
    const input = root.querySelector('input[type="search"]');
    const items = Array.from(root.querySelectorAll('.rs-maker-collection-list li'));
    const status = root.querySelector('.rs-maker-index__status');
    if (!input || !status) return;
    function filter() {
      const query = input.value.trim().toLocaleLowerCase();
      let shown = 0;
      items.forEach(function (item) {
        item.hidden = !item.textContent.toLocaleLowerCase().includes(query);
        if (!item.hidden) shown += 1;
      });
      status.textContent = shown + ' of ' + items.length + ' maker collections';
    }
    input.addEventListener('input', filter);
    filter();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-publication-article"]) return;
  try {
    
function createRsBlogAd(root, type) {
  const client = root.dataset.adClient;
  const slot = type === 'in-article' ? root.dataset.adInArticleSlot : root.dataset.adDisplaySlot;
  const adLabel = root.dataset.adLabel;
  if (!client || !slot || !adLabel) return null;
  const ad = document.createElement('aside');
  ad.className = `rs-blog-ad rs-blog-ad--${type}`;
  ad.setAttribute('aria-label', adLabel);
  const label = document.createElement('span');
  label.className = 'rs-blog-ad__label';
  label.textContent = adLabel;
  const unit = document.createElement('ins');
  unit.className = 'adsbygoogle';
  unit.style.display = 'block';
  unit.style.textAlign = 'center';
  unit.dataset.adClient = client;
  unit.dataset.adSlot = slot;
  if (type === 'in-article') {
    unit.dataset.adLayout = 'in-article';
    unit.dataset.adFormat = 'fluid';
  } else if (type === 'sidebar') {
    unit.style.width = '200px';
    unit.style.height = '200px';
  } else {
    unit.dataset.adFormat = 'auto';
    unit.dataset.fullWidthResponsive = 'true';
  }
  ad.append(label, unit);
  return ad;
}
function placeRsBlogAd(root, body, type, ratio) {
  const candidates = Array.from(body.children).filter(element => !element.matches('.rs-blog-ad, [data-rs-shop-block]'));
  if (!candidates.length) return;
  const total = candidates.reduce((sum, element) => sum + (element.textContent || '').trim().length, 0);
  const target = total * ratio;
  let running = 0;
  let anchor = candidates[candidates.length - 1];
  for (const element of candidates) {
    running += (element.textContent || '').trim().length;
    if (running >= target) {
      anchor = element;
      break;
    }
  }
  const ad = createRsBlogAd(root, type);
  if (!ad) return;
  body.insertBefore(ad, body.firstChild);
  try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (error) {}
}

function initRsSidebarAd(root) {
  const desktop = window.matchMedia('(min-width:990px)');
  const rail = root.querySelector('.rs-publication__rail-inner');
  if (!desktop.matches || !rail || rail.querySelector('.rs-blog-ad--sidebar')) return;
  const ad = createRsBlogAd(root, 'sidebar');
  if (!ad) return;
  rail.append(ad);
  const requestAd = () => {
    if (!desktop.matches || ad.dataset.requested || ad.getBoundingClientRect().width < 202) return;
    ad.dataset.requested = 'true';
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (error) {}
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting) && desktop.matches) {
        requestAd();
        if (ad.dataset.requested) observer.disconnect();
      }
    }, { threshold: 0.1 });
    observer.observe(ad);
  } else {
    requestAd();
  }
}

function initRsPublication(root) {
  if (root.dataset.ready) return;
  const body = root.querySelector('[data-rs-article-body]');
  const index = root.querySelector('[data-rs-index]');
  const list = root.querySelector('[data-rs-index-links]');
  const headings = body.querySelectorAll('h2');
  if (headings.length > 1) {
    headings.forEach((heading, number) => {
      if (!heading.id) heading.id = `rs-reading-${number + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link); list.append(item);
    });
    index.hidden = false;
    index.open = !window.matchMedia('(max-width:749px)').matches;
    body.querySelectorAll('nav').forEach(nav => {
      if (nav.querySelector('.toc')) nav.hidden = true;
    });
  }
  const wordCount = (body.textContent || '').trim().split(/\s+/).filter(Boolean).length;
  if (wordCount >= 700 && !body.querySelector('.rs-blog-ad')) {
    placeRsBlogAd(root, body, 'in-article', 0.46);
  }
  if (wordCount >= 700) initRsSidebarAd(root);
  root.dataset.ready = 'true';
}
document.querySelectorAll('[data-rs-publication]').forEach(initRsPublication);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rs-publication]').forEach(initRsPublication));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-room-snap-preview"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    const page = document.querySelector('.rsrooms-enhanced');
    if (!page || page.dataset.enhancedReady) return;
    page.dataset.enhancedReady = 'true';
    const nav = page.querySelector('.rsrooms-nav');
    const toggles = [...nav.querySelectorAll('.rsrooms-menu-toggle')];
    let active = null;
    const close = (restoreFocus = false) => {
      if (!active) return;
      const trigger = active;
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      active = null;
      if (restoreFocus) trigger.focus();
    };
    toggles.forEach(trigger => trigger.addEventListener('click', () => {
      const wasOpen = active === trigger;
      close();
      if (wasOpen) return;
      active = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = false;
    }));
    nav.addEventListener('click', event => {
      if (event.target.closest('[data-room-close]')) close(true);
      else if (event.target.closest('a')) close();
    });
    nav.addEventListener('keydown', event => {
      if (event.key === 'Escape' && active) { event.preventDefault(); close(true); }
      else if (event.key === 'ArrowDown' && toggles.includes(event.target)) {
        event.preventDefault();
        if (active !== event.target) event.target.click();
        document.getElementById(event.target.getAttribute('aria-controls')).querySelector('a').focus();
      } else if (event.key === 'Tab' && !event.shiftKey && active === event.target) {
        event.preventDefault();
        document.getElementById(active.getAttribute('aria-controls')).querySelector('button').focus();
      }
    });
    document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) close(); });
    document.addEventListener('focusin', event => { if (!nav.contains(event.target)) close(); });
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 761px)');
    const scenes = [...page.querySelectorAll('.rsrooms-scene')];

    const positionArtfulPoints = () => {
      const phone = !desktop.matches;
      const zoom = 1;
      scenes.forEach(scene => {
        const media = scene.querySelector('.rsrooms-scene-media');
        const img = media.querySelector('img');
        const width = media.clientWidth, height = media.clientHeight;
        const iw = phone ? 1122 : 1672, ih = phone ? 1402 : 941;
        const fit = Math.max(width / iw, height / ih);
        scene.querySelectorAll('[data-artful-point]').forEach(dot => {
          const values = dot.dataset.artfulPoint.split(',').map(Number);
          const px = values[phone ? 2 : 0], py = values[phone ? 3 : 1];
          const x = 50 + (px - 50) * iw * fit * zoom / width;
          const y = 50 + (py - 50) * ih * fit * zoom / height;
          dot.style.left = x + '%'; dot.style.top = y + '%';
          dot.style.setProperty('--mx', x + '%'); dot.style.setProperty('--my', y + '%');
        });
      });
    };
    positionArtfulPoints();
    window.addEventListener('resize', positionArtfulPoints, {passive:true});
    const runway = page.querySelector('.rsrooms-runway');
    const stage = page.querySelector('.rsrooms-stage');
    const track = page.querySelector('.rsrooms-track');
    const controls = page.querySelector('.rsrooms-gallery-controls');
    const previous = controls.querySelector('[data-room-previous]');
    const next = controls.querySelector('[data-room-next]');
    const count = controls.querySelector('.rsrooms-gallery-count');
    let horizontal = false, step = 1, start = 0, panelWidth = 0, current = -1, scheduled = false;
    let wheelTotal = 0, wheelDirection = 0, wheelTime = -Infinity, wheelConsumed = false, lockedUntil = 0;
    const title = index => scenes[index].querySelector('h1,h2').textContent;
    const draw = () => {
      scheduled = false;
      if (!horizontal) return;
      const progress = Math.max(0, Math.min(scenes.length - 1, (scrollY - start) / step));
      const index = Math.round(progress);
      page.style.setProperty('--gallery-x', `${-index * panelWidth}px`);
      page.dataset.galleryIndex = index;
      if (current === index) return;
      current = index;
      scenes.forEach((scene, i) => { scene.inert = i !== index; });
      count.textContent = `${String(index + 1).padStart(2,'0')} / ${String(scenes.length).padStart(2,'0')}`;
      previous.disabled = index === 0;
      next.disabled = index === scenes.length - 1;
      previous.setAttribute('aria-label', title(Math.max(0,index - 1)));
      next.setAttribute('aria-label', title(Math.min(scenes.length - 1,index + 1)));
      scenes.slice(Math.max(0,index - 1),index + 3).forEach(scene => { scene.querySelector('img').loading = 'eager'; });
    };
    const requestDraw = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(draw); } };
    const measure = () => {
      horizontal = desktop.matches && !motion.matches && innerHeight > 480;
      page.classList.toggle('rsrooms-horizontal', horizontal);
      if (!horizontal) {
        scenes.forEach(scene => { scene.inert = false; });
        current = -1;
        positionArtfulPoints();
        return;
      }
      const top = nav.offsetHeight;
      const height = innerHeight - top;
      step = Math.max(360, height * .8);
      panelWidth = page.getBoundingClientRect().width;
      page.style.setProperty('--gallery-top', `${top}px`);
      page.style.setProperty('--gallery-height', `${height}px`);
      page.style.setProperty('--gallery-runway', `${height + step * (scenes.length - 1)}px`);
      start = runway.getBoundingClientRect().top + scrollY - top;
      positionArtfulPoints();
      draw();
    };
    const go = (index, focus = false) => {
      index = Math.max(0,Math.min(scenes.length - 1,index));
      if (!horizontal) return;
      window.scrollTo({top:start + index * step,behavior:'instant'});
      draw();
      if (focus) {
        const heading = scenes[index].querySelector('h1,h2');
        heading.tabIndex = -1;
        heading.focus({preventScroll:true});
      }
    };
    page.addEventListener('wheel', event => {
      if (!horizontal || event.ctrlKey || event.metaKey || event.defaultPrevented || nav.contains(event.target)) return;
      const end = start + step * (scenes.length - 1);
      if (scrollY < start - 2 || scrollY > end + 2) return;
      if (event.target.closest('input,textarea,select,[contenteditable="true"],[role="dialog"]')) return;
      const raw = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (!raw) return;
      const delta = raw * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1);
      const direction = Math.sign(delta);
      const now = performance.now();
      if (now - wheelTime > 180 || direction !== wheelDirection) {
        wheelTotal = 0;
        wheelConsumed = false;
      }
      wheelTime = now;
      wheelDirection = direction;
      if (now < lockedUntil || wheelConsumed) {
        event.preventDefault();
        return;
      }
      if ((current === 0 && direction < 0) || (current === scenes.length - 1 && direction > 0)) return;
      event.preventDefault();
      wheelTotal += Math.abs(delta);
      if (wheelTotal < 18) return;
      wheelConsumed = true;
      lockedUntil = now + 460;
      wheelTotal = 0;
      go(current + direction);
    }, {passive:false});
    page.addEventListener('click', event => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || !horizontal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      const index = scenes.findIndex(scene => '#' + scene.id === anchor.getAttribute('href'));
      if (index < 0) return;
      event.preventDefault();
      history.pushState(null,'',anchor.getAttribute('href'));
      go(index,true);
    });
    previous.addEventListener('click', () => go(current - 1));
    next.addEventListener('click', () => go(current + 1));
    const followHash = () => {
      const index = scenes.findIndex(scene => '#' + scene.id === location.hash);
      if (index >= 0 && horizontal) go(index);
    };
    const navSize = new ResizeObserver(() => {
      page.style.setProperty('--room-nav-height', `${nav.offsetHeight + 8}px`);
      measure();
    });
    navSize.observe(nav);
    window.addEventListener('scroll', requestDraw, {passive:true});
    window.addEventListener('resize', measure, {passive:true});
    window.addEventListener('hashchange', followHash);
    window.addEventListener('popstate', followHash);
    window.addEventListener('pageshow', () => { measure(); followHash(); });
    motion.addEventListener('change', measure);
    desktop.addEventListener('change', measure);
    measure();
    followHash();

    const placeReviews = () => {
      const footer = document.querySelector('footer.footer-group');
      const badge = document.querySelector('.jdgm-trust-badge-widget');
      const strip = badge && badge.closest('.shopify-section-group-footer-group');
      const copyright = footer && footer.querySelector('[id$="__footer-copyright"]');
      if (!footer || !strip || !copyright) return false;
      footer.classList.add('rsrooms-furnish-footer');
      strip.classList.add('rsrooms-reviews-strip');
      if (strip.nextElementSibling !== copyright) footer.insertBefore(strip, copyright);
      return true;
    };
    if (!placeReviews()) {
      const observer = new MutationObserver(() => { if (placeReviews()) observer.disconnect(); });
      observer.observe(document.body, {childList:true,subtree:true});
      setTimeout(() => observer.disconnect(), 20000);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
